import axios from "axios";
const ServerUrl = process.env.NEXT_PUBLIC_SERVER_URL;

// console.log("ServerUrl:", ServerUrl);
if (!ServerUrl) {
    console.error("Server URL is not configured. Please check your .env.local file");
}

// Get list of Blog with category + pagination + search + subcategory
export const GetAllBlog = async (
    category = null,
    page = 1,
    pageSize = 12,
    searchQuery = "",
    subcategoryId = null,
    // subcategory = null,
    categorySlug = null
) => {
    try {
        let query = `?populate=*&pagination[page]=${page}&pagination[pageSize]=${pageSize}`;

        // ✅ Sort FIRST before filters (order doesn't matter for Strapi, but keeps it clean)
        query += `&sort[0]=blogDate:desc&sort[1]=publishedAt:desc`;

        // Category filter by slug (preferred if provided)
        if (categorySlug) {
            query += `&filters[category][slug][$eq]=${encodeURIComponent(categorySlug)}`;
        }
        // Category filter by name (fallback)
        else if (category) {
            query += `&filters[category][name][$eq]=${encodeURIComponent(category)}`;
        }

        // Subcategory filter
        if (subcategoryId) {
            query += `&filters[subcategories][id][$eq]=${subcategoryId}`;
        }

        // Search filter (title OR description)
        if (searchQuery) {
            query += `&filters[$or][0][title][$containsi]=${encodeURIComponent(searchQuery)}`;
            query += `&filters[$or][1][description][$containsi]=${encodeURIComponent(searchQuery)}`;
        }

        const res = await axios.get(`${ServerUrl}/articles${query}`);
        return res.data;

    } catch (error) {
        console.error("Error fetching blogs:", error.response?.data || error);
        return null;
    }
};

// Latest blogs for the homepage/course carousels. Requests only card fields:
// the full GetAllBlog() response includes article bodies (~1MB for 12 posts).
export const GetLatestBlogCards = async (pageSize = 12) => {
    try {
        const query =
            `?fields[0]=title&fields[1]=slug&fields[2]=description&fields[3]=blogDate` +
            `&populate[cover][fields][0]=url&populate[cover][fields][1]=formats` +
            `&populate[category][fields][0]=name&populate[author][fields][0]=name` +
            `&sort[0]=blogDate:desc&sort[1]=publishedAt:desc` +
            `&pagination[page]=1&pagination[pageSize]=${pageSize}`;
        const res = await axios.get(`${ServerUrl}/articles${query}`);
        return res.data;
    } catch (error) {
        console.error("Error fetching latest blog cards:", error.response?.data || error);
        return null;
    }
};

// fetch blog categories
export const getCategories = async () => {
    try {
        const res = await axios.get(`${ServerUrl}/categories?sort=name:asc`);
        return res.data;
    } catch (error) {
        console.error("Error fetching categories:", error);
    }
};

export async function fetchSubcategory(categoryId) {
    try {
        if (!ServerUrl) {
            throw new Error("Server URL is not defined");
        }
        const response = await axios.get(`${ServerUrl}/subcategories?filters[category][id][$eq]=${categoryId}`);
        if (!response.data) {
            throw new Error("Invalid response format from API");
        }
        return response.data;
    } catch (error) {
        console.error("Error fetching subcategories:", error);
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(`Failed to fetch subcategories: HTTP status ${error.response.status}`);
        } else {
            throw new Error(`Failed to fetch subcategories: ${error.message}`);
        }
    }
}

// Get category by slug
export const getCategoryBySlug = async (slug) => {
    try {
        const res = await axios.get(`${ServerUrl}/categories?filters[slug][$eq]=${encodeURIComponent(slug)}&populate=*`);
        return res.data?.data?.[0] || null;
    } catch (error) {
        console.error("Error fetching category by slug:", error);
        return null;
    }
};

// Get all categories with slugs
export const getAllCategoriesWithSlugs = async () => {
    try {
        const res = await axios.get(`${ServerUrl}/categories?populate=*&sort=name:asc`);
        return res.data?.data || [];
    } catch (error) {
        console.error("Error fetching categories:", error);
        return [];
    }
};